export class NotificationInstance {
    id!: string
    notificationId!: string
    title!: string
    body!: string
    richBody!: string
    icon!: string
    action!: string
    notes!: string
    sentDate!: Date
    sentByUserId!: string
    category!: string
    expiresOn!: Date

    viewed!: boolean
}
